import chroma from "chroma-js";

export const red_green_palette = ["#FB4141", "#FFC145", "#ECE852","#89b335", "#5CB338"];
export const nature_palette = ["#C2FFC7", "#C2FFC7", "#9EDF9C","#62825D", "#62825D"];
export const space_palette = ["#7977bf", "#8576FF", "#7BC9FF","#A3FFD6"];

export const compare_palette = ["#A55854",  "#C9D3CB","#69C3E1", "#B9936A", "#3E8899"];
export const score_palette =  [
    "#E53935", // 0% - Red
    "#FB8C00", // 10% - Orange Red
    "#FDD835", // 20% - Orange
    "#FFEB3B", // 30% - Yellow
    "#C0CA33", // 40% - Lime
    "#8BC34A", // 50% - Light Green
    "#43A047", // 60% - Green
    "#00897B", // 70% - Teal
    "#00ACC1", // 80% - Cyan
    "#1E88E5"  // 90-100% - Blue
]
export const experiment_palette = [
    "#6C5CE7", // Soft Purple
    "#00B894", // Teal
    "#0984E3", // Sky Blue
    "#E17055", // Orange
    "#74B9FF", // Light Blue
    "#55EFC4", // Mint Green
    "#A29BFE", // Light Purple
    "#FAB1A0", // Light Peach
    "#81ECEC", // Light Cyan
    "#FFEAA7"  // Light Yellow
];

export const tag_palette = [
    "#FF6F61", // Vibrant Coral
    "#FFB74D", // Bright Orange
    "#FFD54F", // Vivid Yellow
    "#AED581", // Fresh Light Green
    "#4DB6AC", // Strong Teal
    "#4FC3F7", // Bright Sky Blue
    "#9575CD", // Vibrant Lavender
    "#BA68C8", // Bright Violet
    "#F06292", // Popping Pink
    "#7986CB"  // Cool Indigo
];

export const subtle_palette = [
    "#F9FAFB", // 1 - near-white
    "#F3F4F6", // 2 - light gray
    "#E5E7EB", // 3 - soft gray
    "#E0E7FF", // 4 - hint of cool blue
    "#F0F9FF", // 5 - hint of sky blue
    "#EFF6FF", // 6 - light periwinkle
    "#ECFDF5", // 7 - minty gray
    "#FEFCE8", // 8 - warm cream
    "#FEF3C7", // 9 - soft yellow
    "#FFE4E6", //10 - blush pink
    "#EDE9FE", //11 - lavender gray
    "#FDE68A", //12 - sunny pastel yellow
    "#C7D2FE", //13 - cornflower blue
    "#A7F3D0", //14 - light mint
    "#FBCFE8", //15 - baby pink
    "#F9A8D4", //16 - subtle pink magenta
    "#FCA5A5", //17 - gentle red
    "#FDBA74", //18 - apricot orange
    "#93C5FD", //19 - soft blue
    "#6EE7B7"  //20 - tropical mint
];

export const features_palette = [
    "#E3F2FD", // Light Blue
    "#E8F5E9", // Light Green
    "#FFFDE7", // Soft Yellow
    "#FCE4EC", // Pale Pink
    "#F3E5F5", // Lavender
    "#ECEFF1", // Cool Gray
    "#FBE9E7", // Light Peach
    "#E0F7FA", // Aqua Blue
    "#F9FBE7", // Pale Lime
    "#FFF3E0"  // Soft Orange
];

export const boxColors = [
    "#AFCFF5",
    "#C8F2A7",
    "#FFD28A",
    "#F5A5A5",
    "#D8B6FF",
    "#A6F2E0",
    "#FFF3A6",
    "#B2EBF2",
    "#FFCCE5",
    "#D3F5A6",
    "#FFB27F",
    "#C5C6FA"
];

export const greenPalette = [
    '#e8f5e9',
    '#c8e6c9',
    '#a5d6a7',
    '#81c784',
    '#66bb6a',
    '#4caf50',
    '#43a047',
    '#388e3c',
    '#2e7d32',
    '#1b5e20',
];

export const redPalette = [
    '#ffebee',
    '#ffcdd2',
    '#ef9a9a',
    '#e57373',
    '#ef5350',
    '#f44336',
    '#e53935',
    '#d32f2f',
    '#c62828',
    '#b71c1c',
].reverse();

export const grayPalette = [
    '#f9f9f9', // almost white
    '#f0f0f0',
    '#e0e0e0',
    '#cccccc',
    '#b3b3b3',
    '#999999',
    '#7f7f7f',
    '#666666',
    '#4d4d4d',
    '#333333'  // near black
];




export const getInterpolatedColor = (palette,value, min, max) => {
    const normalizedValue = (Math.max(min, Math.min(value, max)) - min) / (max - min);
    const scale = chroma.scale(palette).mode('lab'); // Create a color scale
    return scale(normalizedValue).hex(); // Get the color at the normalized value
};